import { render } from "./CompetitiveAnalysis.vue?vue&type=template&id=06c8be02&scoped=true&ts=true"
import script from "./CompetitiveAnalysis.vue?vue&type=script&lang=ts"
export * from "./CompetitiveAnalysis.vue?vue&type=script&lang=ts"

import "./CompetitiveAnalysis.vue?vue&type=style&index=0&id=06c8be02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c8be02"]])

export default __exports__